<template>
  <div>
    <div class="flex flex-wrap items-center justify-between">
      <h2 class="text-3xl font-bold">
        Records
      </h2>
      <!-- <div class="space-x-3">
        <dropdown align="right" class="z-10">
          <button class="w-full btn btn-secondary btn-sm">
            Last 7 Days
          </button>
          <div slot="dropdown" class="w-56 py-2 text-sm bg-white border rounded shadow-lg">
            <button v-for="option in dateRangeOptions" :key="option.label" class="w-full px-4 py-2 text-left hover:bg-gray-50" :class="{ 'text-indigo-500': option.active }" @click.prevent="">
              <fa :icon="['far', 'check']" class="mr-2 opacity-0" :class="{ 'opacity-100': option.active }" /> {{ option.label }}
            </button>
          </div>
        </dropdown>
        <dropdown align="right" class="z-10">
          <button class="w-full btn btn-secondary btn-sm">
            28 Aug - 05 Sep
          </button>
          <div slot="dropdown" class="rounded-lg shadow-lg ">
            <DatePicker  color="indigo" mode="dateTime" is-range v-model="date" is-inline />
          </div>
        </dropdown>
      </div> -->
    </div>
    
    <div class="mt-5 divide-y card">
      <div class="grid grid-cols-1 divide-y md:divide-y-0 md:divide-x md:grid-cols-3">
        <div class="flex items-center px-4 py-5 sm:p-6">
          <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-teal-500 rounded-md">
            <fa :icon="['far', 'file-check']" size="lg" fixed-width />
          </div>
          <div class="flex-1 w-0 ml-5">
            <dl>
              <dt class="text-xs font-medium tracking-wider text-gray-500 uppercase truncate">
                Records Captured
              </dt>
              <dd class="flex items-baseline">
                <div class="text-2xl font-semibold leading-8 text-gray-900">
                  718
                </div>
              </dd>
            </dl>
          </div>
        </div>
        <div class="flex items-center px-4 py-5 sm:p-6">
          <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-teal-500 rounded-md">
            <fa :icon="['far', 'sack-dollar']" size="lg" fixed-width />
          </div>
          <div class="flex-1 w-0 ml-5">
            <dl>
              <dt class="text-xs font-medium tracking-wider text-gray-500 uppercase truncate">
                Total Amount Recorded
              </dt>
              <dd class="flex items-baseline">
                <div class="text-2xl font-semibold leading-8 text-gray-900">
                  R18.75k
                </div>
              </dd>
            </dl>
          </div>
        </div>
        <div class="flex items-center px-4 py-5 sm:p-6">
          <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 text-white bg-teal-500 rounded-md">
            <fa :icon="['far', 'car-mechanic']" size="lg" fixed-width />
          </div>
          <div class="flex-1 w-0 ml-5">
            <dl>
              <dt class="text-xs font-medium tracking-wider text-gray-500 uppercase truncate">
                Records Per Vehicle
              </dt>
              <dd class="flex items-baseline">
                <div class="text-2xl font-semibold leading-8 text-gray-900">
                  4.5
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 divide-x md:grid-cols-3">
        <div>
          <cost-per-kilometre />
        </div>
        <div>
          <cost-per-trip />
        </div>
        <div>
          <cost-per-hour />
        </div>
      </div>
      <div class="grid grid-cols-1 divide-x md:grid-cols-3">
        <div>
          <cost-per-record />
        </div>
        <div>
          <total-expenses />
        </div>
        <div>
          <total-kilometres />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Sparkline from '@/components/Sparkline'
import CostPerKilometre from './records/CostPerKilometre'
import CostPerTrip from './records/CostPerTrip'
import CostPerHour from './records/CostPerHour'
import CostPerRecord from './records/CostPerRecord'
import TotalExpenses from './records/TotalExpenses'
import TotalKilometres from './records/TotalKilometres'

export default {
  name: 'OverviewRecords',

  components: {
    CostPerKilometre,
    CostPerTrip,
    CostPerHour,
    CostPerRecord,
    TotalExpenses,
    TotalKilometres,
    DatePicker,
    Sparkline
  },
  
  data () {
    return {
      date: [],
      dateRangeOptions: [
        { label: 'Today', value: 'today' },
        { label: 'Last 7 Days', value: '7d', active: true },
        { label: 'Last 4 Weeks', value: '4w' },
        { label: 'Last 3 Months', value: '3m' },
        { label: 'Last 12 Months', value: '12m' },
        { label: 'Month to Date', value: 'mtd' },
        { label: 'Quarter to Date', value: 'qtd' },
        { label: 'Year to Date', value: 'ytd' },
        { label: 'All Time', value: 'all' }
      ],
      total: {
        primary: 124214,
        secondary: 13483
      },
      series: [{
        name: 'series-1',
        data: [
          { x: 'Sep 2019', y: 3532 }, 
          { x: 'Oct 2019', y: 2678 }, 
          { x: 'Nov 2019', y: 3453 }, 
          { x: 'Dec 2019', y: 1200 },
          { x: 'Jan 2020', y: 6782 }, 
          { x: 'Feb 2020', y: 1267 }, 
          { x: 'Mar 2020', y: 3532 }, 
          { x: 'Apr 2020', y: 2678 }, 
          { x: 'May 2020', y: 3453 }, 
          { x: 'Jun 2020', y: 1200 }, 
          { x: 'Jul 2020', y: 6782 }, 
          { x: 'Aug 2020', y: 1267 },
          { x: 'Sep 2020', y: 0 }
        ]
      }]
    }
  }
}
</script>